import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-vanity',
		path: '/admin/custom_urls/new',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_vanity" */ './index'), {
			exportName: 'Vanity',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
		frame: true,
	},
];
